import $ from 'jquery';
import 'datatables.net';
import {InventoryApi} from '../api/apicollection';

const SAFE_STOR_ADDENDUM_URL = '/Content/SafeStorTenantAcknowledgementAddendum.html';

export default function InsuranceViewModel() {
    let dt = $(".form__insurance-table").DataTable({
        "paging": false,
        "ordering": false,
        "info": false,
        "searching": false
    });

    this.insurance = ko.observableArray([]);
    this.selectedInsurance = ko.observable();
    this.isSafeStor = ko.observable();

    this.FormatCaption = function (amount) {
        if (amount == 0) return 'Use my homeowners/renters insurance †';
        return `Up to $${amount.toLocaleString()} in personal property damage`;
    };
    this.SetInsurance = ins => {
        const isSafeStor = ins.amount != 0 ? true : false;
        document.getElementById('RentableInventoryAddOnId').value = ins.rentableInventoryAddOnID;
        document.getElementById('InsuranceAmount').value = ins.amount;
        document.getElementById('IsSafeStor').value = isSafeStor;
        document.getElementById('InsuranceCaption').value = ins.caption;
        this.selectedInsurance(ins.rentableInventoryAddOnID);
        this.isSafeStor(isSafeStor);
        return true;
    }

    this.Load = () => {
        InventoryApi.getInsuranceForInventory(document.getElementById('RentableInventoryId').value).then(data => {
            //Add Homeowners to insurance data
            data.data.push({amount: 0, rentableInventoryAddOnID: null, insuranceCoverageAmount: 0, caption: 'INSURANCE Homeowners/Renters', active: true});
            this.insurance(data.data);
            this.SetInsurance(data.data[0]);
        });
    };
    this.Load();

    return this;
};

$('#insurance-form').submit(() => {
    if (document.getElementById('ShowInsuranceAddendum').value === 'True') { //check if feature flag is turned on.
        window.open(SAFE_STOR_ADDENDUM_URL);
    }
});